import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './catalog/App';
import { Provider } from 'react-redux';
import store from './catalog/store';
import './catalog/i18n';

window.MobileDetect = require('mobile-detect');
window.Parallax = require('parallax-js');
require('../../lib/game-icons');
require('../../lib/game-demo');
require('./subscription');

window.initGamesCatalog = () => {
  const catalog = ReactDOM.createRoot(
    document.getElementById('games-catalog')
  );
  catalog.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
};
